import React, { useEffect } from "react";
import {
  SavingsWrapper,
  SavingsGridBox,
  StoryBox,
  SavingsTextHeader,
  LeftSection,
  NavLink,
  RightSection,
  SavingsHeader,
  TextBox,
  LearnMore,
} from "./SmartSavings.styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export const SmartSavings = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <SavingsWrapper>
      <SavingsHeader>
        <LeftSection>
          <h3>
            Savings made flexible, fun and easily hitting target goals
            seamlessly possible
          </h3>
          <NavLink to="/">Start Saving</NavLink>
        </LeftSection>
        <RightSection>
          <img src="img/rafiki1.jpg" alt="" />
        </RightSection>
      </SavingsHeader>
      <TextBox>
        <p>
          Now that you have fully understood how to better manage your finances,
          cultivating a savings discipline is crucial to improve your financial
          standing, with our well outlined saving plans you get to figure out
          what you would like to save towards, how much it requires, how long it
          would take and set your desired savings goals.
        </p>
      </TextBox>

      <div>
        <SavingsTextHeader>Target Savings for Kids</SavingsTextHeader>

        <SavingsGridBox>
          <StoryBox>
            <h3>Basic</h3>
            <p>Long term savings designed For Kids,</p>
            <p>managed by the parents.</p>
            <div>
              <LearnMore to="/savings-stage">
                <span>Learn more</span>
                <ArrowForwardIosIcon sx={{ fontSize: "60%" }} />
              </LearnMore>
            </div>
          </StoryBox>
          <StoryBox>
            <h3>Level Up</h3>
            <p>Annual/One time savings designed For </p>
            <p>kids, managed By the parents</p>

            <div>
              <LearnMore to="/annual-savings">
                <span>Learn more</span>
                <ArrowForwardIosIcon sx={{ fontSize: "60%" }} />
              </LearnMore>
            </div>
          </StoryBox>
        </SavingsGridBox>
      </div>

      <div>
        <SavingsTextHeader>
          <p className="savingsText">Smart Savings built for a seamless hitting of all savings goal</p>
        </SavingsTextHeader>

        <SavingsGridBox>
          <StoryBox>
            <h3>Special Savers</h3>
            <p>Short term savings</p>
            <p>Designed to easily cultivate savings </p>
            <p>discipline.</p>

            <div>
              <LearnMore to="/short-term-savings">
                <span>Learn more</span>
                <ArrowForwardIosIcon sx={{ fontSize: "60%" }} />
              </LearnMore>
            </div>
          </StoryBox>
          <StoryBox>
            <h3>Special Champions</h3>

            <p>Target goal savings smartly designed </p>
            <p>To make easily hitting target goals</p>
            <p> seamlessly Possible</p>

            <div>
              <LearnMore to="/target-goal">
                <span>Learn more</span>
                <ArrowForwardIosIcon sx={{ fontSize: "60%" }} />
              </LearnMore>
            </div>
          </StoryBox>
          <StoryBox>
            <h3>Special legends</h3>
            <p>Long term target goal Savings</p>
            <p>Smartly designed to make</p>
            <p>Hitting massive target goals seamlessly Possible</p>

            <div>
              <LearnMore to="/long-term-goal">
                <span>Learn more</span>
                <ArrowForwardIosIcon sx={{ fontSize: "60%" }} />
              </LearnMore>
            </div>
          </StoryBox>
          <StoryBox>
            <h3>
              Group Savings <br /> Achievements
            </h3>

            <p>Group target savings Optimally designed to </p>
            <p>enableAn effective collective Savings</p>

            <div>
              <LearnMore to="/group-target-savings">
                <span>Learn more</span>
                <ArrowForwardIosIcon sx={{ fontSize: "60%" }} />
              </LearnMore>
            </div>
          </StoryBox>
        </SavingsGridBox>
      </div>
    </SavingsWrapper>
  );
};
